import { Component, OnInit, Output, Input, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { PartnersService } from '../../../../../app/core/routing/services/Partners_api/partners.service';
import { OemConstants } from '../../../../../app/core/routing/services/oem/constants/oem.constants';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Partners } from '../../Partners/Interface/partner.i';
import { systemID } from '../../../oem-portal/interface/oem-portal-interface.i';
import { reviewPartnerConfiguration } from '../../Review-partner-content/Interface/review-partner.i';
import { PartnerContentStore } from '../../store/partner-content-store';
import { OemService } from '../../../../../app/core/routing/services/oem/oem.service';
import { StoresConstant } from '../../../../../app/core/routing/services/stores_api/constants/stores.constant';
import { DevicesConstants } from '../../../../../app/core/routing/services/devices/constants/devices.constants';
import { ActiveUserConstants } from '../../../../../app/core/routing/services/activeusers_api/constatnts/activeusers.constant';
import { GlobalConstants } from '../../../../../app/common/constants/global.constant';
import { first } from 'rxjs/internal/operators/first';

@Component({
  selector: 'iposcen-system-ids',
  templateUrl: './system-ids.component.html',
  styleUrls: ['./system-ids.component.scss']
})
export class SystemIdsComponent implements OnInit {
  @ViewChild('searchValue') animateThis: ElementRef;
  @ViewChild('deleteSystemIdModal') deleteSystemIdModal: ElementRef;
  @ViewChild('deleteAckModal') deleteAckModal: ElementRef;
  isNoneSelected = true;
  searchClose = false;
  loadFlag: string;
  searchTag: string;
  filterString: string;
  selectFilterQueue = {};
  searchQueue = {};
  sortQueue = {};
  searchSystemIDPlaceHolderText = OemConstants.SEARCH_SYSTEMID_PLACEHOLDER_TXT;
  partner: Partners[];
  partnerData: any;
  getPartnerDetails: any = {};
  spinnerStatus = true;
  maxSize = 5;
  allPartnerData: reviewPartnerConfiguration[] = [];
  globalSortBy: string;
  globalSortValue: string;
  page: number;
  pID: any;
  contents: systemID[];
  showFrom: number;
  showTo: number;
  paginationCount: number;
  searchData: string;
  tableSize: number;
  partnerLabel: string;
  partnerID: any;
  selectedButton: string;
  isPartnerEmpty: boolean;
  isSystemIdOpen = false;
  systemIDDataSearch = false;
  isSystemIDSearch = false;
  globConst = GlobalConstants;
  deleteTooltip = this.globConst.DELETE;
  systemIdDeleteEnable = false;
  noSystemIdSelected = true;
  systemIDsToDelete = [];
  sytemIdToDelete: string;
  isSystemIdListEmpty: boolean;
  isMasterSel = false;
  isAllSelectedData = new Map();
  isSelectAllClicked = false;
  displaySystemIDs = [];
  sytemIDName: string;
  isAllsystemIdsSelected: boolean;
  selectedSystemIdsList = [];
  selectedSystemIdNameList: string;
  isSingleSystemIdSelected: boolean;
  conflictingModelId: string;
  oemConst = OemConstants;
  displayModelName = [];
  ellipsesCount = 12;
  modelSKUNAME = [];
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private partnersService: PartnersService, private store: PartnerContentStore, private oemService: OemService) { }

  ngOnInit(): void {
    this.page = 1;
    this.tableSize = 10;
    this.showFrom = 0;
    this.showTo = 0;
    this.paginationCount = 0;
    this.isNoneSelected = true;
    this.loadFlag = StoresConstant.LOAD_FLAG;
    this.selectedButton = OemConstants.SELECT_PARTNER;
    this.globalSortBy = OemConstants.UPDATE_TIME;
    this.globalSortValue = OemConstants.DESCENDING_ORDER;
    this.getAllSystemIDPartnerData();
  }

  selectedPartnerList(data, pID) {
    this.partnerLabel = data;
    this.pID = pID;
    this.selectedButton = data;
    this.page = 1;
    if (this.isSystemIDSearch) {
      this.searchData = ActiveUserConstants.EMPTY_VALUE;
      this.searchData = '';
      this.isSystemIDSearch = false;
      this.searchQueue = {};
      this.getSystemIdSortSearchData();
    } else {
      this.getSystemIdSortSearchData();
    }
    this.resetSystemIdDelete();
  }

  getSystemIDContentData(pID, filterString?: string) {
    this.oemService.getSystemIDDataUsingPartnerID(this.globalSortBy, this.globalSortValue, this.page, pID, filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getApprovedPartnerResponse => {
        this.contents = getApprovedPartnerResponse.SystemIDs as systemID[];
        this.modelSKUNAME = this.contents;
        this.extractConflictingModelIds();
        this.contents.forEach(ele => {
          ele.isSelected = this.isMasterSel;
          this.displaySystemIDs.push(ele);
        });
        this.isSystemIdListEmpty = (this.contents.length === 0) || false;
        this.paginationCount = (getApprovedPartnerResponse.paginationContext.totalItems);
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        this.systemIDDataSearch = (this.contents.length === 0 && this.isSystemIDSearch) || false;
        this.displaySystemIDs = [];
        this.contents.forEach(ele => {
          ele.isSelected = this.isMasterSel;
          this.displaySystemIDs.push(ele);
        });
        if (this.systemIdDeleteEnable && this.systemIDDataSearch) {
          this.isMasterSel = false;
          this.isAllSelectedData.clear();
          this.isSelectAllClicked = false;
          this.systemIdDeleteEnable = false;
          this.systemIDsToDelete = [];
        }
        if (this.displaySystemIDs.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
        } else {
          this.displaySystemIDs = [];
          this.contents.forEach(ele => {
            ele.isSelected = this.isMasterSel;
            this.displaySystemIDs.push(ele);
          });
        }
        this.checkModelName();
      });
  }

  getAllSystemIDPartnerData() {
    this.partnersService.getOEMSystemIds()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllPartnerResponse => {
        this.partner = getAllPartnerResponse.partnerName;
        this.partnerID = getAllPartnerResponse.partnerID;
        this.isPartnerEmpty = (this.partner.length == 0) || false;
        let temp = new Map()
        this.partner.forEach((e, i) => {
          temp.set(e, this.partnerID[i])
        })
        this.partnerData = new Map([...temp.entries()].sort());
        this.partner = Array.from(this.partnerData.keys());
        this.partnerID = Array.from(this.partnerData.values());
      });
  }

  onTableDataChange(event) {
    this.page = event;
    this.getSystemIDContentData(this.pID, this.filterString);
  }

  sortingTableWithAscandDesc(tempval: string) {
    this.globalSortValue = this.globalSortValue !== OemConstants.ASCENDING_ORDER ? OemConstants.ASCENDING_ORDER :
      OemConstants.DESCENDING_ORDER;
    this.globalSortBy = tempval;
    this.getSystemIDContentData(this.pID, this.filterString);
  }

  sort(sortKey: string) {
    this.isSelectAllClicked = false;
    this.isMasterSel = false;
    this.noSystemIdSelected = true;
    switch (sortKey) {
      case ('systemID'):
        this.sortingTableWithAscandDesc('systemID');
        break;
      case ('systemModels'):
        this.sortingTableWithAscandDesc('systemModels');
        break;
      case ('detectionStatus'):
        this.sortingTableWithAscandDesc('detectionStatus');
        break;
      case ('editedByName'):
        this.sortingTableWithAscandDesc('editedByName');
        break;
      case ('updatedTime'):
        this.sortingTableWithAscandDesc('updatedTime');
        break;
      default: {
      }
    }
  }

  checkStatusCase(data) {
    if (data === 'approved') {
      return data.replace(data, 'Approved');
    } else if (data === 'submitted') {
      return data.replace(data, 'Submitted');
    } else if (data === 'returned') {
      return data.replace(data, 'Returned');
    } else if (data === 'delete requested') {
      return data.replace(data, 'Delete Requested');
    }
  }

  searchSystemIdReport(searchData) {
    this.searchClose = true;
    this.isSystemIDSearch = true;
    this.isAllSelectedData.clear();
    this.isSelectAllClicked = false;
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.searchTag = DevicesConstants.SYSTEMID_SEARCH;
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      this.searchQueue = {};// To clear previous Profile search seletion
      this.searchQueue[this.searchTag] = encodeURIComponent(searchData);
      this.getSystemIdSortSearchData();
    } else {
      this.getSystemIDContentData(this.pID);
      this.page = 1;
    }
    this.isMasterSel = false;
    this.isNoneSelected = true;
  }

  searchSytemIDOnEnter(searchData) {
    this.isMasterSel = false;
    this.isNoneSelected = true;
    this.isAllSelectedData.clear();
    this.isSelectAllClicked = false;
    this.isSystemIDSearch = true;
    this.animateThis.nativeElement.blur();
    this.searchSystemIdReport(searchData);
  }

  getSystemIdSortSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.searchQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
    }
    if (this.filterString !== '') {
      this.getSystemIDContentData(this.pID, this.filterString);
    } else {
      this.getSystemIDContentData(this.pID);
    }
  }

  clearSystemIdSearch() {
    this.searchQueue = {};
    this.getSystemIdSortSearchData();
    this.searchData = ActiveUserConstants.EMPTY_VALUE;
    this.animateThis.nativeElement.value = '';
    this.searchData = '';
    this.page = 1;
    this.isSystemIDSearch = false;
    this.isMasterSel = false;
    this.isAllSelectedData.clear();
    this.isNoneSelected = true;
    this.resetSystemIdDelete();
  }

  onSystemIdSearchInput(val: string) {
    if (val?.length === 0) {
      this.clearSystemIdSearch();
    }
  }

  multiDeleteSystemId() {
    this.noSystemIdSelected = true;
    this.systemIdDeleteEnable = true;
  }

  resetSystemIdDelete() {
    this.systemIdDeleteEnable = false;
    this.systemIDsToDelete = [];
    this.isMasterSel = false;
    this.isAllSelectedData.clear();
    this.isSelectAllClicked = false;
    this.noSystemIdSelected = true;
  }

  openSystemIdDeletePopup(autoID: string, systemID: string) {
    this.isSingleSystemIdSelected = true;
    this.sytemIdToDelete = this.contents.find(ele => ele.autoID === autoID).autoID;
    this.sytemIDName = this.contents.find(ele => ele.systemID === systemID).systemID;
    this.openModal(this.deleteSystemIdModal);
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  deleteSystemIdContent(autoID: string) {
    let systemIDsMultiDelete: any = {};
    if (!this.isSingleSystemIdSelected && this.isSingleSystemIdSelected !== undefined) {
      systemIDsMultiDelete = { autoIDList: this.selectedSystemIdsList.map(item => item.autoID) }
    } else {
      systemIDsMultiDelete = { autoIDList: [autoID] }
    }
    this.oemService.deleteSystemIDContentByIds(systemIDsMultiDelete)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(() => {
        const index = this.contents.findIndex(d => d.autoID === autoID);
        if (index >= 0) {
          this.contents.splice(index, 1);
        }
        this.isSystemIdListEmpty = (this.contents.length === 0) || false;
        this.closeModal(this.deleteSystemIdModal);
        this.openModal(this.deleteAckModal);
        setTimeout(_ => {
          this.getSystemIDContentData(this.pID, this.filterString);
        }, 2000);
        this.resetSystemIdDelete();
        this.isMasterSel = false;
        this.isAllSelectedData.clear();
      },
        error => {
          this.closeModal(this.deleteSystemIdModal);
          this.closeModal(this.deleteAckModal);
        });
    this.systemIDsToDelete = [];
  }

  isAllSelected(data) {
    this.isSelectAllClicked = false;
    if (this.isAllSelectedData.has(data.autoID)) {
      this.isAllSelectedData.delete(data.autoID);
    } else {
      this.isAllSelectedData.set(data.autoID, data);
    }
    this.displaySystemIDs.forEach(ele => {
      ele.isSelected = this.isAllSelectedData.has(ele?.autoID);
    });
    if (this.isAllSelectedData.size === this.paginationCount) {
      this.isMasterSel = true;
    } else {
      this.isMasterSel = false;
    }
    this.getSelectedSystemIdsList();
  }

  checkUncheckAll(event) {
    if (this.filterString) {
      this.isAllSelectedData.clear();
      if (event) {
        this.isSelectAllClicked = true;
        this.isMasterSel = this.isSelectAllClicked;
        this.oemService.selectAllSystemIDs(this.filterString, this.pID)
          .subscribe(res => {
            {
              res.SystemIDs.forEach(value => {
                this.isAllSelectedData.set(value.autoID, value);
              });
              this.checkSelectAllStatus();
              this.getSelectedSystemIdsList();
            }
          });
      } else {
        this.isSelectAllClicked = false;
        this.isAllSelectedData.clear();
        this.getSelectedSystemIdsList();
      }
    } else {
      if (event) {
        this.isSelectAllClicked = true;
        this.isMasterSel = this.isSelectAllClicked;
        this.oemService.selectAllSystemIDs(this.filterString, this.pID)
          .subscribe(res => {
            res.SystemIDs.forEach(value => {
              this.isAllSelectedData.set(value.autoID, value);
            });
            this.checkSelectAllStatus();
            this.getSelectedSystemIdsList();
          });
      } else {
        this.isSelectAllClicked = false;
        this.isAllSelectedData.clear();
        this.getSelectedSystemIdsList();
      }
    }
  }

  checkSelectAllStatus() {
    this.displaySystemIDs.forEach(ele => {
      ele.isSelected = this.isAllSelectedData.has(ele?.autoID);
    });

    const isAllChecked = this.displaySystemIDs.every(item => {
      if (item?.isSelected) {
        return true;
      }
    });
    this.isMasterSel = isAllChecked;
    this.isAllsystemIdsSelected = this.isMasterSel;
  }

  getSelectedSystemIdsList() {
    this.selectedSystemIdsList = Array.from(this.isAllSelectedData.values());
    this.selectedSystemIdNameList = this.selectedSystemIdsList.map(e => e.systemID)
      .join(', ');
    this.noSystemIdSelected = this.selectedSystemIdsList.length ? false : true;
  }

  deleteMultiSelectSystemIds() {
    if (this.selectedSystemIdsList.length > 0) {
      this.openModal(this.deleteSystemIdModal);
      if (this.selectedSystemIdsList.length === 1) {
        this.isSingleSystemIdSelected = true;
        let singleUser = this.contents.filter(item => item.systemID === this.selectedSystemIdsList[0].systemID);
        if (singleUser.length > 0) {
          this.sytemIDName = singleUser[0]?.systemID;
        }
      } else {
        this.isSingleSystemIdSelected = false;
      }
    }
  }

  extractConflictingModelIds() {
    this.contents.forEach((obj) => {
      if (obj.errorMessage) {
        const pattern = /conflictingModelId=([^}]+)}/;
        const match = obj.errorMessage.match(pattern);
        if (match && match[1]) {
          obj.conflictingModelId = match[1];
        } else {
          obj.conflictingModelId = null;
        }
      } else {
        obj.conflictingModelId = null;
      }
    });
  }

  checkIfList(data) {
    return typeof data !== 'object';
  }

  checkArray(data) {

    try {
      let temp = JSON.parse(data);
      if (typeof temp === 'number') {
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  checkModelName() {
    this.displayModelName = [];
    this.modelSKUNAME.forEach(data => {
      if (this.checkArray(data.systemModels)) {
        let temp = JSON.parse(data.systemModels);
        if ((temp[0] + temp[1]).length < this.ellipsesCount) {
          if (temp.length === 2) {
            data.systemModels = temp[0] + ',' + temp[1];
          } else {
            data.systemModels = [(temp[0] + ',' + temp[1]).slice(0, this.ellipsesCount) + '...', temp, 'popup2'];
          }

        } else {

          data.systemModels = temp[0].toString().length >= this.ellipsesCount ? [temp[0].toString().slice(0, this.ellipsesCount) + '...', temp, 'popup1'] :
            [(temp[0] + ',' + temp[1]).slice(0, this.ellipsesCount) + '...', temp, 'popup1'];
        }
      } else {
        data.systemModels = data.systemModels.length < this.ellipsesCount ? data.systemModels : [data.systemModels.slice(0, this.ellipsesCount) + '...', data.systemModels, 'tooltip']
      }

      this.displayModelName.push(data);
    });
    this.contents = this.displayModelName;
  }
}
